import { Pipe, PipeTransform } from '@angular/core';

import { getLocaleFromLang } from '../constants/constants';
import moment from 'moment';
import momentTz from 'moment-timezone';

type DatexPreset =
  | 'short'
  | 'long'
  | 'timeOnly'
  | 'dateOnly'
  | 'iso'
  | 'datetime';
type DatexLang = 'de' | 'us' | 'en' | 'fr' | 'nl' | 'es' | 'es-ct' | 'ch-de';

@Pipe({ name: 'datex' })
export class DatexPipe implements PipeTransform {
  private readonly presetFormats: Record<
    DatexPreset,
    Partial<Record<DatexLang | 'default', string>>
  > = {
    short: {
      de: 'DD.MM.YYYY HH:mm',
      'ch-de': 'DD.MM.YYYY HH:mm',
      us: 'MM/DD/YYYY HH:mm',
      en: 'MM/DD/YYYY HH:mm',
      fr: 'DD/MM/YYYY HH:mm',
      nl: 'DD-MM-YYYY HH:mm',
      es: 'DD/MM/YYYY HH:mm',
      'es-ct': 'DD/MM/YYYY HH:mm',
      default: 'DD.MM.YYYY HH:mm',
    },
    long: {
      de: 'dddd, DD.MM.YYYY HH:mm',
      'ch-de': 'dddd, DD.MM.YYYY HH:mm',
      us: 'dddd, MM/DD/YYYY HH:mm',
      en: 'dddd, MM/DD/YYYY HH:mm',
      fr: 'dddd, DD/MM/YYYY HH:mm',
      nl: 'dddd, DD-MM-YYYY HH:mm',
      es: 'dddd, DD/MM/YYYY HH:mm',
      'es-ct': 'dddd, DD/MM/YYYY HH:mm',
      default: 'dddd, DD.MM.YYYY HH:mm',
    },
    timeOnly: {
      default: 'HH:mm',
    },
    dateOnly: {
      de: 'DD.MM.YYYY',
      'ch-de': 'DD.MM.YYYY',
      us: 'MM/DD/YYYY',
      en: 'MM/DD/YYYY',
      fr: 'DD/MM/YYYY',
      nl: 'DD-MM-YYYY',
      es: 'DD/MM/YYYY',
      'es-ct': 'DD/MM/YYYY',
      default: 'DD.MM.YYYY',
    },
    iso: {
      default: 'YYYY-MM-DDTHH:mm:ss[Z]',
    },
    datetime: {
      de: 'DD.MM.YYYY HH:mm',
      'ch-de': 'DD.MM.YYYY HH:mm',
      us: 'MM/DD/YYYY HH:mm',
      en: 'MM/DD/YYYY HH:mm',
      fr: 'DD/MM/YYYY HH:mm',
      nl: 'DD-MM-YYYY HH:mm',
      es: 'DD/MM/YYYY HH:mm',
      'es-ct': 'DD/MM/YYYY HH:mm',
      default: 'DD.MM.YYYY HH:mm',
    },
  };

  private readonly languageDefaultFormats: Record<string, string> = {
    de: 'DD.MM.YYYY HH:mm',
    'ch-de': 'DD.MM.YYYY HH:mm',
    us: 'MM/DD/YYYY HH:mm',
    en: 'MM/DD/YYYY HH:mm',
    fr: 'DD/MM/YYYY HH:mm',
    nl: 'DD-MM-YYYY HH:mm',
    es: 'DD/MM/YYYY HH:mm',
    'es-ct': 'DD/MM/YYYY HH:mm',
  };

  transform(
    value: any,
    format: string = '',
    timeZone: string = '',
    lang?: string,
    mode: 'local' | 'utc' = 'local'
  ): string {
    if (!value) {
      return value;
    }

    const localeKey = (
      lang ??
      localStorage.getItem('language') ??
      ''
    ).toLowerCase();
    const resolvedFormat = this.resolveFormat(format, localeKey);

    const m = timeZone
      ? momentTz.tz(value, timeZone)
      : mode === 'utc'
        ? moment.utc(value)
        : moment(value);

    if (!m.isValid()) {
      return value;
    }

    if (localeKey) {
      m.locale(getLocaleFromLang(localeKey));
    }

    return resolvedFormat ? m.format(resolvedFormat) : m.toString();
  }

  private resolveFormat(format: string, localeKey: string): string {
    if (!format) {
      return (
        this.languageDefaultFormats[localeKey] ??
        this.languageDefaultFormats[localeKey.split('-')[0]] ??
        this.languageDefaultFormats.de
      );
    }

    const preset = format as DatexPreset;
    const presetConfig = this.presetFormats[preset];

    if (presetConfig) {
      return (
        presetConfig[localeKey as DatexLang] ??
        presetConfig[localeKey.split('-')[0] as DatexLang] ??
        presetConfig.default ??
        this.languageDefaultFormats.de
      );
    }

    return format;
  }
}

/*import { Pipe, PipeTransform } from '@angular/core';

import { getLocaleFromLang } from '../constants/constants';
import moment from 'moment';
import momentTz from 'moment-timezone';

@Pipe({ name: 'datex' })
export class DatexPipe implements PipeTransform {
  transform(
    value: any,
    format: string = '',
    timeZone: string = '',
    lang?: string
  ): string {
    if (!value) {
      return value;
    }

    let m = timeZone ? momentTz.tz(value, timeZone) : moment(value);

    if (!m.isValid()) {
      return value;
    }

    if (lang) {
      console.log(lang);
      m = m.locale(getLocaleFromLang(lang));
    } else {
      const savedLang = localStorage.getItem('language');
      if (savedLang) {
        m = m.locale(getLocaleFromLang(savedLang));
      }
    }

    return format ? m.format(format) : m.toString();
  }
}*/
